/**
 * «Панель занятия», slices 1–3 (docs/design/lesson-hub.md): attendance
 * from the lesson's start, the payment line, «Написать». Pure, so it is
 * tested without a browser (scripts/verify/lesson-hub.ts).
 *
 * Nothing here decides money: «Получено» goes through the existing
 * /paid endpoint, which takes cash bookings only, and a credits lesson
 * is settled by the server after it ends whatever is marked here.
 */

/** Less than this left on a cash lesson is rounding: nothing to collect. */
export const ROUND_OFF = 1;

type Status = 'booked' | 'attended' | 'no_show' | string;

/**
 * Пришёл / Не пришёл, from the moment the lesson starts. Shown once
 * marked as well, so a mis-tap or a late arrival can be switched; the
 * route allows booked ↔ attended ↔ no_show at any time.
 */
export function attendanceOpen(lesson: { starts_at: string }, b: { status: Status; lateCancel?: boolean }, now: number) {
  if (b.lateCancel) return false;
  if (b.status !== 'booked' && b.status !== 'attended' && b.status !== 'no_show') return false;
  return now >= new Date(lesson.starts_at).getTime();
}

/** What a tap on a chip sends; null when that chip is already on. */
export function attendanceChange(current: Status, pressed: 'attended' | 'no_show'): 'attended' | 'no_show' | null {
  return current === pressed ? null : pressed;
}

export type PayLine =
  | { kind: 'collect'; owed: number }
  | { kind: 'paid' }
  | { kind: 'balance' };

/**
 * The panel's payment line. Cash: what is left to collect («Получено…»),
 * or paid. Credits — old rule or credit-on-use — show the payer's
 * balance instead; there is no «Получено» on them.
 */
export function payLine(b: {
  paymentMode: 'credits' | 'cash'; amountDue: number | null; received?: number | null; paidAt: string | null;
}): PayLine {
  if (b.paymentMode !== 'cash') return { kind: 'balance' };
  if (b.paidAt) return { kind: 'paid' };
  const owed = Math.max(0, Number(b.amountDue ?? 0) - Number(b.received ?? 0));
  if (b.amountDue != null && owed < ROUND_OFF) return { kind: 'paid' };
  return { kind: 'collect', owed };
}

/** «Написать»: their Telegram chat, else a call; null when there is neither. */
export function messageHref(username: string | null | undefined, phone: string | null | undefined): string | null {
  const u = (username ?? '').trim().replace(/^@/, '');
  if (/^[A-Za-z0-9_]{3,32}$/.test(u)) return `https://t.me/${u}`;
  const p = (phone ?? '').replace(/[\s().-]/g, '');
  if (/^\+?\d{6,15}$/.test(p)) return `tel:${p}`;
  return null;
}
